<template>
  <div :class="{ 'scrollbar-hide-mobile': isScrollbarHide() }">
    <div
      v-if="emptyCategory"
      :style="{
        height: this.getHeight(),
        paddingBottom: this.getPaddingBottom(),
        top: this.getTop(),
      }"
      class="nav_line"
      :class="{ 'scrollbar-hide-mobile': isScrollbarHide() }"
    >
      <ul
        :id="'bubbles-nav-' + level"
        class="nav_line_list"
        :style="{ marginBlockEnd: level ? '1em' : '-10px' }"
      >
        <template v-for="category in categories">
          <!-- <li
            v-if="isSeeCategory(category)"
            :id="bubbleId(category)"
            :key="category.id"
          > -->
          <li
            v-if="category"
            :id="bubbleId(category)"
            :key="category.id"
          >
            <a
              :class="{
                act:
                  currentCategory &&
                  (currentCategory.id === category.id ||
                    currentCategory.parent_id === category.id),
              }"
              @click="selectCategory(category)"
            >
              {{ category.name }}
            </a>
          </li>
        </template>
      </ul>
    </div>
    <bubbles-navbar
      :categories-prop="children"
      :height="this.height"
      :level="level + 1"
      :product_block_prefix="product_block_prefix"
      :product_bubble_prefix="product_bubble_prefix"
      v-if="children.length !== 0"
    ></bubbles-navbar>
  </div>
</template>

<script>
  import {
    SET_LOADING,
    SET_MODAL,
    SET_SELECTED_CATEGORY
  } from '@/store/mutations.type'
  import {SELECT_CATEGORY} from '@/store/actions.type'
  import {isMobile} from 'mobile-device-detect'

  export default {
    name: 'BubblesNavbar',
    props: {
      product_bubble_prefix: String,
      product_block_prefix: String,
      level: Number,
      categoriesProp: Array,
      height: Number
    },
    data() {
      return {
        children: [],
        categories: JSON.parse(JSON.stringify(this.categoriesProp))
      }
    },
    components: {},
    computed: {
      currentCategory() {
        return this.$store.getters.selectedCategory[this.level].current
      },
      emptyCategory() {
        if (this.categories[0].is_not_deleted && this.categories.length === 1) {
          return false
        } else {
          return true
        }
      }
    },
    watch: {
      categoriesProp(categoriesProp) {
        this.categories = JSON.parse(JSON.stringify(categoriesProp))
      },
      currentCategory(category) {
        this.scrollToBubble(category)
        this.getChildren(category)
      }
    },
    mounted() {
      this.getChildren(this.$store.getters.selectedCategory[this.level].current)
      this.scrollToBubble(
        this.$store.getters.selectedCategory[this.level].current
      )

      this.$store.subscribe((mutation) => {
        if (mutation.type === SET_SELECTED_CATEGORY) {
          for (let i in this.categories) {
            if (this.categories[i].id === mutation.payload.category.id) {
              this.scrollToBubble(this.categories[i])
            }
          }
        }
      })
    },
    methods: {
      isSeeCategory(category) {
        let result = false
        if (category.dishes_count > 0) {
          result = true
        } else {
          this.$store.getters.categories.forEach(el => {
            if (el.parent_id === category.id && el.dishes_count > 0) {
              result = true
            }
          })
        }
        return result
      },
      isScrollbarHide() {
        return isMobile
      },
      getTop() {
        if (this.level === 0) {
          return 0
        } else if (this.level === 1) {
          return this.height + 'px'
        } else {
          return (
            this.height + (36 + (this.height - 36) / 2) * (this.level - 1) + 'px'
          )
        }
      },
      getHeight() {
        if (this.level === 0) {
          return this.height + 'px'
        } else {
          return 36 + 'px' // nav_line_list height
        }
      },
      getPaddingBottom() {
        if (this.level === 0) {
          return 0
        } else {
          return (this.height - 36) / 2 + 'px'
        }
      },
      getChildren(category) {
        this.children = []
        if (!category || category.id == null) {
          return
        }

        for (let i in this.$store.getters.categories) {
          if (this.$store.getters.categories[i].parent_id === category.id) {
            if (
              this.$store.getters.categories[i].work_time.is_working_now ||
              (this.$store.getters.categories[i].work_time.from !== null &&
                this.$store.getters.categories[i].work_time.to !== null)
            ) {
              this.children.push(this.$store.getters.categories[i])
            }
          }
        }
      },

      bubbleId(category) {
        return this.product_bubble_prefix + category.id
      },

      selectCategory(category) {
        this.$store.dispatch(SELECT_CATEGORY, {
          category,
          categories: this.categories,
          level: category.level,
          block: true
        })
        this.$scrollTo('#' + this.product_block_prefix + category.id, 200, {
          onDone: () => {
            this.$store.commit(SET_LOADING, {
              process: SELECT_CATEGORY,
              loading: false
            })
          },
          offset: -(this.height * (this.level + 1))
        })
      },

      scrollToBubble(category) {
        if (!category || category.id == null) {
          return
        }

        let nav = document.getElementById('bubbles-nav-' + this.level)

        if (!nav) {
          return
        }

        let parent = nav.parentElement
        let bubble = document.getElementById(this.bubbleId(category))

        if (bubble) {
          parent.scrollLeft +=
            bubble.getBoundingClientRect().x - parent.getBoundingClientRect().x
          if (
            Math.abs(
              Math.floor(
                parent.getBoundingClientRect().x -
                bubble.getBoundingClientRect().x
              )
            ) < 10
          ) {
            parent.scrollLeft += -30
          }
        }
      }
    }
  }
</script>
